import React, { Component } from 'react';
import Search from '../CommissionSearch';
import Api from '../../Api';
import { browserHistory } from 'react-router';
import * as actions from '../../redux/actions';

class Complete extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    var address = '';
    if (this.props.org.address) address += this.props.org.address + ', ';
    if (this.props.org.city) address += this.props.org.city + ', ';
    if (this.props.org.state) address += this.props.org.state;
    return (
      <div className='container'>
        <div className='content pure-g' style={{ textAlign: 'center' }}>
          <h1 className='pure-u-1'>Kiosk Org Assignment Complete!</h1>
          <div
            className='pure-u-1'
            style={{ fontSize: 152, textAlign: 'center', marginBottom: 20 }}
          >
            <i className='animated zoomIn fa fa-thumbs-up '></i>
          </div>
          <p className='pure-u-1-3'>
            <span className=''>Name</span>
            <br />
            <br />
            {this.props.name}
          </p>
          <p className='pure-u-1-3'>
            <span className=''>Org Name</span>
            <br />
            <br />
            {this.props.org.name}
          </p>
          <p className='pure-u-1-3'>
            <span className=''>Org Address</span>
            <br />
            <br />
            {address}
          </p>
          <div className='pure-u-1-4'></div>
          <div className='pure-u-1-2' style={{ marginTop: 40 }}>
            <button
              className='pure-button button-regular button-secondary'
              onClick={() => {
                this.props.handleClick();
              }}
            >
              Restart
            </button>
          </div>
          <div className='pure-u-1-4'></div>
        </div>
      </div>
    );
  }
}

class CommissionPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kioskName: '',
      orgs: [],
      org: {},
      isComplete: false,
      error: '',
      isValidKiosk: false,
      isValidOrg: false,
      isLoading: false,
    };
  }

  componentDidMount() {
    Api.getOrgList().then((data) => {
      let orgList = data || [];
      this.setState({ orgs: orgList });
    });
  }

  validateKiosk() {
    return Api.getKiosk(this.state.kioskName)
      .then((kiosk) => {
        let error = kiosk.org ? 'An org already exists for this kiosk.' : '';
        let isValidKiosk = !error;
        this.setState({ error: error, isValidKiosk, isLoading: false });
        return isValidKiosk;
      })
      .catch((error) => {
        console.log(error);
        let err = error.data && error.data.msg ? error.data.msg : 'Unknown Error';
        this.setState({ error: err, isValidKiosk: false, isLoading: false });
        return error;
      });
  }

  handleInput(e) {
    this.setState({ kioskName: e.target.value, isValidKiosk: false });
  }

  handleKeyPress(e) {
    if (e.key === 'Enter' && this.state.kioskName) {
      this.validateKiosk();
      this.setState({ isLoading: true });
    }
  }

  handleProfileClick(e) {
    e.preventDefault();
    browserHistory.push('/user/profile');
  }

  handleLogout() {
    let { dispatch } = this.props;
    dispatch(actions.logoutUser()).then(() => {
      browserHistory.push('/logout');
    });
  }

  handleOrgClick(org) {
    console.log('selected org : ', org);
    this.setState({ isValidOrg: org != {}, org: org });
  }

  handleRestart(input) {
    this.setState({ isComplete: false, kioskName: '', isValidKiosk: false });
  }

  handleSubmit() {
    if (this.state.kioskName && this.state.org.id) {
      this.validateKiosk().then((isValidKiosk) => {
        if (isValidKiosk) {
          Api.setOrg(this.state.kioskName, this.state.org.id)
            .then((res) => {
              this.setState({ isComplete: res.updated >= 0 });
            })
            .catch((e) => {
              let msg = 'Failed to assign kiosk to org. Error: ' + e.msg;
              alert(msg);
            });
        }
      });
    }
  }

  renderOrg() {
    if (!this.state.isValidKiosk) {
      return null;
    }
    return (
      <Search
        data={this.state.orgs}
        handleClick={(org) => {
          this.handleOrgClick(org);
        }}
        org={this.state.org}
      />
    );
  }

  renderLoading() {
    if (!this.state.isLoading) {
      return null;
    }
    return (
      <div style={{ textAlign: 'center', marginTop: 20, fontSize: 52 }}>
        <i className='fa fa-circle-o-notch fa-spin'></i>
        <br />
      </div>
    );
  }

  renderSubmit() {
    if (
      !this.state.kioskName ||
      !this.state.org.name ||
      !this.state.isValidKiosk ||
      !this.state.isValidOrg
    ) {
      return null;
    }
    return (
      <button
        className='pure-button button-primary button-regular'
        onClick={() => {
          this.handleSubmit();
        }}
      >
        Submit
      </button>
    );
  }

  render() {
    var email = this.props.auth.user.email;

    if (this.state.isComplete) {
      return (
        <Complete
          handleClick={() => this.handleRestart()}
          name={this.state.kioskName}
          org={this.state.org}
        />
      );
    }

    return (
      <div className='container'>
        <header className='nav-row pure-g'>
          <div className='pure-u-1-3'></div>
          <div className='pure-u-1-3'>
            <img className='' src='/img/dash-logo.png' style={{ margin: 15, height: 20 }} />
          </div>
          <div className='pure-u-1-3 header-right' style={{ textAlign: 'right' }}>
            <a className='profile' onClick={this.handleProfileClick.bind(this)}>
              {email}
            </a>
            |
            <a className='logout' onClick={this.handleLogout.bind(this)}>
              Logout
            </a>
          </div>
        </header>
        <div className='content'>
          <h1 style={{ margin: 20 }}>Assign a Kiosk to an Org</h1>
          <h2 className=''>Scan the Kiosk Barcode</h2>
          <div className='pure-form pure-form-horizontal pure-g'>
            <div className='pure-u-1-4'></div>
            <div className='pure-u-1-2'>
              <input
                className='kiosk-name'
                id='kioskName'
                type='text'
                placeholder='Scan barcode to set Kiosk Name'
                value={this.state.kioskName}
                onChange={this.handleInput.bind(this)}
                onKeyPress={this.handleKeyPress.bind(this)}
              />
            </div>
            <div className='pure-u-1-4'></div>
            <div className='pure-u-1' style={{ color: 'red', textAlign: 'center' }}>
              {this.state.error}
            </div>
            <div className='pure-u-1-4'></div>
            <div className='pure-u-1-2'>
              {this.renderOrg()}
              {this.renderLoading()}
            </div>
            <div className="pure-u-1-4"></div>
            <div className="pure-u-1-4"></div>
            <div className="pure-u-1-2" >
              {this.renderSubmit()}
            </div>
            <div className="pure-u-1-4"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default CommissionPage;



// WEBPACK FOOTER //
// ./src/components/pages/CommissionPage.js